export default "__VITE_ASSET__SvorzDhN__"